import React, { useEffect, useRef } from "react";
import Footer from "../../../components/layout/Footer/Footer";
import { FrmttdPrc } from "../../../components/FormattedPrice/FormattedPrice";
import {
  Btn,
  Container,
  H1,
  H2,
  ImgContainer,
  Text1,
  Span,
  Block,
  ImgBlock,
  TitleBlock,
  TextBlock,
  Box,
  CircleText1,
  BoxText,
  BoxTitleB,
  BoxTitleN,
  CircleContainer,
  Box1,
  ImgCont,
  TextCont,
  TextBlock1,
  TitleBlock1,
  TextWrap,
  SmallText,
  Container1,
  Btn2,
  Box2,
  Box21,
  SmallText1,
  H1W,
  H2W,
  BtnW,
  FAQCont2,
  FAQuestion,
  Spinner,
  FAQCircle,
  FAQ1,
  InnerText,
} from "./styles";
import { goTo, useNavigation } from "../../../types/Navigates";
import {
  Block1Container,
  Btn5,
  BtnText,
  Circle,
  CircleText,
  Item,
  ItemContainer1,
  ItemContainer2,
  ItemContainer3,
  ItemText,
  Meeting,
  Price,
  ScrollContainer2,
  Smth,
  X,
} from "../../Main/styles";
import { FAQText } from "../../../components/FAQ/styles";
import { FAQ } from "../../../components/FAQ/FAQ";
import { Tag } from "../../../components/Ratings/styles";
import { Ratings } from "../../../components/Ratings/Ratings";
import { BookingPopup } from "../../../components/BookingPopUp/ThePopup/BookingPopup";
import urlText from "../../../types/urlText";
import { BoxText2, BoxTitleN2 } from "../Services1/styles";
import { CircleContainer2 } from "../Services2/styles";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getCard } from "../../../store/slices/cardSlice";
import { getProductCategories } from "../../../store/slices/productCategoriesSlice";

const Services4 = () => {
  const { toServices, toConsult, toMain, toRatings } = useNavigation();
  const scrollcontainerRef = useRef(null);
  const innerTextRef1 = useRef(null);
  const innerTextRef2 = useRef(null);
  const innerTextRef3 = useRef(null);
  const innerTextRef4 = useRef(null);
  const container1Ref = useRef(null);

  useEffect(() => {
    const scrollcontainer = scrollcontainerRef.current;
    const innerText1 = innerTextRef1.current;
    const innerText2 = innerTextRef2.current;
    const innerText3 = innerTextRef3.current;
    const innerText4 = innerTextRef4.current;
    const container1 = container1Ref.current;
  });

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  useEffect(() => {
    dispatch(getCard(8));
    dispatch(getProductCategories());
  }, []);
  const card = useSelector((state: RootState) => state.card.card);
  const product1 = card.filter((item) => item.product_category.id === 9);
  const product2 = card.filter((item) => item.product_category.id === 12);
  const product3 = card.filter((item) => item.product_category.id === 7);
  const productCategories = useSelector(
    (state: RootState) => state.productCategories.productCategories
  );
  const productCats1 = productCategories.find((item) => item.id === 9);
  const productCats2 = productCategories.find((item) => item.id === 12);
  const productCats3 = productCategories.find((item) => item.id === 7);

  const scroll = () => {
    if (scrollcontainerRef.current) {
      scrollcontainerRef.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollcontainerRef.current.scrollLeft += evt.deltaY;
      });
    }
  };

  const scroll2 = () => {
    if (container1Ref.current) {
      container1Ref.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        container1Ref.current.scrollLeft += evt.deltaY;
      });
    }
  };
  const ShowinnerText1 = () => {
    if (innerTextRef1.current) {
      innerTextRef1.current.style.display == "none"
        ? (innerTextRef1.current.style.display = "block")
        : (innerTextRef1.current.style.display = "none");
    }
  };
  const ShowinnerText2 = () => {
    if (innerTextRef2.current) {
      innerTextRef2.current.style.display == "none"
        ? (innerTextRef2.current.style.display = "block")
        : (innerTextRef2.current.style.display = "none");
    }
  };
  const ShowinnerText3 = () => {
    if (innerTextRef3.current) {
      innerTextRef3.current.style.display == "none"
        ? (innerTextRef3.current.style.display = "block")
        : (innerTextRef3.current.style.display = "none");
    }
  };
  const ShowinnerText4 = () => {
    if (innerTextRef4.current) {
      innerTextRef4.current.style.display == "none"
        ? (innerTextRef4.current.style.display = "block")
        : (innerTextRef4.current.style.display = "none");
    }
  };
  const smthRef = useRef(null);
  const smth = smthRef.current;
  const ShowPopUp = () => {
    smthRef.current.style.display = "block";
    window.scrollTo(0, 0);
  };
  const HidePopUp = () => {
    smthRef.current.style.display = "none";
  };
  console.log('productCats1:', productCats1);
  return (
    <>
      <Smth ref={smthRef}>
        <X onClick={HidePopUp} $img={require("../../Main/X.jpg")}></X>
        <BookingPopup />
      </Smth>
      <ImgContainer $img={require("./bg.png")}>
        {productCats2 ? <H1>{productCats2.title}</H1> : <></>}
        <H2>Подготовим вас к поиску работы и поможем взять нужный оффер.</H2>
        <Btn onClick={goTo}>Бесплатная консультация</Btn>
      </ImgContainer>
      <Container>
        <Text1>
          Кому подходит
          <Span>сопровождение?</Span>
        </Text1>
      </Container>
      <Container>
        <Block>
          <ImgBlock $img={require("./v1.png")} />
          <TitleBlock>Не знаете как искать работу</TitleBlock>
          <TextBlock>
            Не умеете продавать себя на современном рынке труда
          </TextBlock>
        </Block>
        <Block>
          <ImgBlock $img={require("./v2.png")} />
          <TitleBlock>Не уверены в себе</TitleBlock>
          <TextBlock>
            Синдром самозванца и отсутствие внутреннего профессионала внутри
          </TextBlock>
        </Block>
        <Block>
          <ImgBlock $img={require("./v3.png")} />
          <TitleBlock>Оффер за рубежом</TitleBlock>
          <TextBlock>Не умеете себя продать на мировой арене</TextBlock>
        </Block>
      </Container>
      <Text1>Как строится работа?</Text1>
      <Container>
        <Box>
          <CircleContainer2>
            <Circle />
            <CircleText1>01</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Построим</BoxTitleN>
          <BoxTitleB>Прогноз</BoxTitleB>
          <BoxText>Обсудим запрос до оплаты, построим прогноз поиска</BoxText>
        </Box>
        <Box>
          <CircleContainer2>
            <Circle />
            <CircleText1>02</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Планируем</BoxTitleN>
          <BoxTitleB>Подготовку</BoxTitleB>
          <BoxText>
            Создадим Резюме, Linkedin, CL и проведем тестовое интервью
          </BoxText>
        </Box>
        <Box>
          <CircleContainer2>
            <Circle />
            <CircleText1>03</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Старт</BoxTitleN>
          <BoxTitleB>Работы</BoxTitleB>
          <BoxText>
            Приступим к поиску работы: показ вакансий и контактов, работа с
            откликами
          </BoxText>
        </Box>
        <Box1>
          <CircleContainer2>
            <Circle />
            <CircleText1>04</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Будем</BoxTitleN>
          <BoxTitleB>Рядом 24/7</BoxTitleB>
          <BoxText>
            Консультант будет рядом с вами 24/7 и поможет: пройти интервью, быть
            в ресурсе и взять оффер
          </BoxText>
        </Box1>
      </Container>
      <Text1>
        Что вы получите<Span>в итоге ?</Span>
      </Text1>
      <Container>
        <ImgCont $img={require("./bg2.png")} />
        <TextCont>
          <TextWrap>
            <TitleBlock1>Упаковка профиля</TitleBlock1>
            <TextBlock1>
              Доработаем или вместе создадим с нуля резюме, профиль в LinkedIn и
              конструктор мотивационных писем. Сделаем вас видимым для HR’ов.
            </TextBlock1>
          </TextWrap>
          <TextWrap>
            <TitleBlock1>Стратегия отклика</TitleBlock1>
            <TextBlock1>
              Определимся с критериями поиска и расставим приоритеты вместе с
              ментором. Разработаем Roadmap. Никаких “слепых” откликов,
              осознанный точечный поиск, приносящий результат.
            </TextBlock1>
          </TextWrap>
          <TextWrap>
            <TitleBlock1>Вакансии и рефералы</TitleBlock1>
            <TextBlock1>
              Обеспечим вас подходящими вакансиями и найдем рефералов.
            </TextBlock1>
          </TextWrap>
        </TextCont>
      </Container>
      <SmallText>ТАРИФЫ</SmallText>
      <Text1>Как мы можем помочь</Text1>
      <Container1 ref={container1Ref}>
        <Block1Container>
          {product1 && productCats1 ? (
            product1.map((product) => (
              <Item $img={require("./item23.png")}>
                <ItemContainer1>
                  <CircleContainer>
                    <Circle />
                    <CircleText>{productCats1.title}</CircleText>
                  </CircleContainer>
                  <ItemText>{product.title}</ItemText>
                </ItemContainer1>
                <ItemContainer2>{product.description}</ItemContainer2>
                <ItemContainer3>
                  <Meeting>{product.duration_text}</Meeting>
                  <FrmttdPrc value={product.price} />
                  <Tag>{product.tag}</Tag>
                  <Btn2 onClick={ShowPopUp}>
                    <BtnText>Заказать</BtnText>
                  </Btn2>
                </ItemContainer3>
              </Item>
            ))
          ) : (
            <></>
          )}
          {product2 && productCats2 ? (
            product2.map((product) => (
              <Item $img={require("./item23.png")}>
                <ItemContainer1>
                  <CircleContainer>
                    <Circle />
                    <CircleText>{productCats2.title}</CircleText>
                  </CircleContainer>
                  <ItemText>{product.title}</ItemText>
                </ItemContainer1>
                <ItemContainer2>{product.description}</ItemContainer2>
                <ItemContainer3>
                  <Meeting>{product.duration_text}</Meeting>
                  <FrmttdPrc value={product.price} />
                  <Tag>{product.tag}</Tag>
                  <Btn2 onClick={ShowPopUp}>
                    <BtnText>Заказать</BtnText>
                  </Btn2>
                </ItemContainer3>
              </Item>
            ))
          ) : (
            <></>
          )}
          {product3 && productCats3 ? (
            product3.map((product) => (
              <Item $img={require("./item23.png")}>
                <ItemContainer1>
                  <CircleContainer>
                    <Circle />
                    <CircleText>{productCats3.title}</CircleText>
                  </CircleContainer>
                  <ItemText>{product.title}</ItemText>
                </ItemContainer1>
                <ItemContainer2>{product.description}</ItemContainer2>
                <ItemContainer3>
                  <Meeting>{product.duration_text}</Meeting>
                  <FrmttdPrc value={product.price} />
                  <Tag>{product.tag}</Tag>
                  <Btn2 onClick={ShowPopUp}>
                    <BtnText>Заказать</BtnText>
                  </Btn2>
                </ItemContainer3>
              </Item>
            ))
          ) : (
            <></>
          )}
        </Block1Container>
      </Container1>
      <Text1>
        Мы приносим<Span>результат</Span>
      </Text1>
      <Container>
        <Box>
          <BoxTitleN2>200+</BoxTitleN2>
          <BoxText2>Клиентов, которые купили сопровождение </BoxText2>
        </Box>
        <Box2>
          <BoxTitleN2>1</BoxTitleN2>
          <BoxText2>
            Месяц – это среднее время поиска работы в сопровождении
          </BoxText2>
        </Box2>
        <Box2>
          <BoxTitleN2>80%</BoxTitleN2>
          <BoxText2>Клиентов, приходят по сарафанному радио</BoxText2>
        </Box2>
        <Box2>
          <BoxTitleN2>20</BoxTitleN2>
          <BoxText2>Cтран, где мы закрываем карьерные запросы</BoxText2>
        </Box2>
        <Box21>
          <BoxTitleN2>4+</BoxTitleN2>
          <BoxText2>Года работы компании Prohorova Consult</BoxText2>
        </Box21>
      </Container>
      <Text1>Отзывы</Text1>
      <ScrollContainer2 ref={scrollcontainerRef}>
        <Ratings />
      </ScrollContainer2>
      <Btn5 onClick={toRatings}>Все отзывы</Btn5>
      <ImgContainer $img={require("./bg3.png")}>
        <SmallText1>бесплатная консультация</SmallText1>
        <H1W>Остались вопросы ?</H1W>
        <H2W>
          Консультация-знакомство это возможность получить ответы на все
          волнующие вопросы.
        </H2W>
        <BtnW href={`https://t.me/ProhorovaConsult?text=${urlText}`}>
          Оставить заявку
        </BtnW>
      </ImgContainer>
      <br />
      <br />
      <br />
      <br />
      <Container>
        <FAQ />
        <FAQCont2>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Как можно узнать подробней об услуге ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText1} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef1}>
            Оставьте заявку на сайте, менеджер свяжется с вами и назначит
            встречу-знакомство, где подробно разберем ваш кейс и расскажем о
            прогнозах поиска.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Можно оплатить услугу частями ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText2} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef2}>
            Да, вы можете оплатить услугу несколькими частями. Мы готовы
            согласовать с вами удобный формат.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Как юридически оформлена работа ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText3} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef3}>
            Мы заключаем договор, где прописаны все условия и критерии
            выполнения услуги.
          </InnerText>
        </FAQCont2>
      </Container>
      <Footer />
    </>
  );
};
export default Services4;
